import PptxGenJS from 'pptxgenjs';
import TextPropsOptions = PptxGenJS.TextPropsOptions;

export const fontFace = 'Arial';

export const h1: TextPropsOptions = {
	fontFace,
	fontSize: 24,
	lineSpacing: 32,
	charSpacing: 0,
	bold: true
};

export const h2: TextPropsOptions = {
	fontFace,
	fontSize: 20,
	charSpacing: 0,
	lineSpacing: 26,
	bold: true
};

export const h3: TextPropsOptions = {
	fontFace,
	fontSize: 14,
	charSpacing: 0,
	lineSpacing: 18,
	bold: true
};

export const copy: TextPropsOptions = {
	fontFace,
	fontSize: 8,
	lineSpacing: 12,
	charSpacing: 0
};

export const copyBold: TextPropsOptions = {
	...copy,
	bold: true
};

export const copySmall: TextPropsOptions = {
	...copy,
	fontSize: 7,
	lineSpacing: 10
};

export const copySmallBold: TextPropsOptions = {
	...copySmall,
	bold: true
};

export const copyMini: TextPropsOptions = {
	...copy,
	fontSize: 6,
	lineSpacing: 8
};
